function createOverlay(image, cancelCheck) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', image.src);

  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);

    if (cancelCheck()) {
      image.style.opacity = '100%';
      return;
    }

    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.position = 'absolute';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '10';
}

function toggleLoadingSpinner(image, forceHide = false) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector(`.loading-overlay__spinner`);
  if (loadingSpinner) {
    if (forceHide) {
      loadingSpinner.classList.add('hidden');
    } else {
      loadingSpinner.classList.toggle('hidden');
    }
  }
}

function moveWithHover(image, event, zoomRatio, overlay) {
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnifyOnHover(image, zoomRatio) {
  let overlay = null;
  let cancel = false;

  image.addEventListener('mouseenter', () => {
    cancel = false;
    overlay = createOverlay(image, () => cancel);
  });

  image.addEventListener('mousemove', (event) => {
    if (overlay) {
      moveWithHover(image, event, zoomRatio, overlay);
    }
  });

  image.addEventListener('mouseleave', () => {
    cancel = true;
    if (overlay) {
      overlay.remove();
      overlay = null;
    }
    image.style.opacity = '100%';
    toggleLoadingSpinner(image, true);
  });
}

function magnifyToggleOnClick(image, zoomRatio) {
  let overlay = null;

  image.addEventListener('click', (event) => {
    event.preventDefault();

    if (!overlay) {
      overlay = createOverlay(image);
      moveWithHover(image, event, zoomRatio, overlay);

      overlay.addEventListener('mousemove', (e) => {
        moveWithHover(image, e, zoomRatio, overlay);
      });

      image.setAttribute('data-magnified', 'true');
    } else {
      overlay.remove();
      overlay = null;
      image.removeAttribute('data-magnified');
    }
  });
}

function enableZoom(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  const isDesktop = window.innerWidth > 991;

  images.forEach(image => {
    image.onclick = null;
    image.removeEventListener('mouseenter', () => {}); // optional cleanup if needed

    if (isDesktop) {
      // magnifyOnHover(image, zoomRatio);
    } else {
      // magnifyToggleOnClick(image, zoomRatio);
    }
  });
}

enableZoom(2);
